import apiCore from '../../utils/api-core';

export default {
	authenticate(body) {
		return apiCore.post('/api/v1/authenticate', body);
	},
	requestVerification(body) {
		return apiCore.post('/api/v1/nexmo/two-factor-auth/request', body)
	},
	checkVerification(body) {
		return apiCore.post('/api/v1/nexmo/two-factor-auth/check', body)
	},
	cancelVerification(body) {
		return apiCore.post('/api/v1/nexmo/two-factor-auth/cancel', body)
	}
};
